import { useState, useEffect } from "react";
import { GetServices } from "screens/Requests/logic/GetServices";
import { SaveService } from "./SaveService";
import { useDefaultResourceLogic } from "./default-resource-logic";
import { useServicePermission } from "../permissions/ServicePermissions";

export const useServiceLogic = ({ setLoading, toast, navigate, handleCloseServiceDlg, serviceContent,fetchServices }) => {
    //#region Permissions
    const { ServicePermissionProps } = useServicePermission();
    const {
        hasServiceSavePermission,
        hasServiceIndustriesGetPermission,
    } = ServicePermissionProps;
    //#endregion Permissions

    const { DefaultResourceProps } = useDefaultResourceLogic();
    const {
        handleSaveDefaultResources
    } = DefaultResourceProps;

    const initialServiceState = {
        serviceOfferingID: 0,
        serviceOfferingName: null,
        industryID: null,
        description: null,
        flatRate: null,
        isActive: true
    }
    const [service, setService] = useState(initialServiceState);
    const [industries, setIndustries] = useState([]);
    const [serviceErrors, setServiceErrors] = useState({});
    
    const fetchIndustries = async () => {
        if(!hasServiceIndustriesGetPermission) return;

        let isMounted = true; // Track if component is still mounted
        try {
            const data = await GetServices(navigate);
            if (isMounted) {
                setIndustries(data);
            }
        } catch (error) {
            console.error("Error fetching services data:", error);
        }

        return () => { isMounted = false }; // Cleanup function
    }

    useEffect(() => {
        if (Object.keys(serviceErrors).length > 0) {
            const timer = setTimeout(() => {
                setServiceErrors({});
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [serviceErrors])

    const isNumberOnly = (input) => {
        const numberRegex = /^\d*\.?\d*$/   
        return numberRegex.test(input);
      }

    const handleServiceChange = (field, value) => {
        if(!hasServiceSavePermission) return;

        if(field === 'flatRate'){
            if(isNumberOnly(value)){
                setService((prevState) => ({ ...prevState, [field]: value }));
            }
        }else{
            setService((prevState) => ({ ...prevState, [field]: value }));
        }        
    }

    const validateFields = () => {
        let tempErrors = {};
        if (!service.serviceOfferingName || service.serviceOfferingName === '') tempErrors.serviceOfferingName = 'Service Name is required';
        if (!service.industryID || service.industryID < 0) tempErrors.industryID = 'Industry is required';
        //if (!service.flatRate) tempErrors.flatRate = 'Flat Rate is required';        

        setServiceErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    }

    const ResetService = () => {
        setService(initialServiceState);
    }

    const handleSaveService = async (assets, materials, labors, subcontractors, otherCosts) => {
        if(!hasServiceSavePermission) return;

        if (validateFields()) {
            setLoading(true);
            try {
                const response = await SaveService(service, navigate);
                if (response && !response.isError) {
                    const resourcesSaved = await handleSaveDefaultResources(
                        assets, materials, labors, subcontractors, otherCosts, response.result.serviceOfferingID
                    );

                    if(resourcesSaved){
                        toast.success('Resources saved successfully.', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            style: {
                                fontFamily: '"DM Sans", sans-serif',
                                fontSize: '15px',
                            },
                        });

                        handleCloseServiceDlg();
                    }
                
                    fetchServices(); 
                    ResetService();
                    
                    toast.success(serviceContent.notification, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                         theme: "light",
                        style: {
                            fontFamily: '"DM Sans", sans-serif',
                            fontSize: '15px',
                        },
                    });
                } else {
                    toast.error(response.message || 'Service failed to saved.', {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                          theme: "light",
                        style: {
                            fontFamily: '"DM Sans", sans-serif',
                            fontSize: '15px',
                        },
                    });
                }
            } catch (error) {
                console.error('Error saving Service:', error);
            } finally {                
                setLoading(false);
            }
        }
    }

    const ServiceProps = {
        service,
        industries,
        setIndustries,
        serviceErrors,
        setServiceErrors,
        handleServiceChange,
        fetchIndustries,
        validateFields,
        ResetService,
        handleSaveService,
        setService
    }

    return { ServiceProps };

}